import { schema } from 'normalizr';
import parseSpecificDate from 'common/utils/date/parseSpecificDate';

export const BUS_TRANSACTION_LIST_SCHEMA_KEY = 'busTransactionList';

const parseDepartureDateTime = transactionListInventory => {
  const { departureDateTime, ...rest } = transactionListInventory;
  let { specificDate } = departureDateTime;
  const { timeZoneId } = departureDateTime;
  specificDate = parseSpecificDate(specificDate);
  return { ...rest, departureDateTime, specificDate, timeZoneId };
};

const parseTransactionTimestamp = transactionListInventory => {
  const { transactionTimestamp, ...rest } = transactionListInventory;
  let { specificDate } = transactionTimestamp;
  const { timeZoneId } = transactionTimestamp;
  specificDate = parseSpecificDate(specificDate);
  return { ...rest, transactionTimestamp, specificDate, timeZoneId };
};

function createBusTransactionListInventorySchema(isReservationList = false) {
  return new schema.Entity(
    BUS_TRANSACTION_LIST_SCHEMA_KEY,
    {},
    {
      idAttribute: ({ tripItineraryId }) => `${tripItineraryId}`,
      processStrategy: (value, parent, key) => {
        if (isReservationList && value.departureDateTime) {
          return parseDepartureDateTime(value);
        } else if (value.transactionTimestamp) {
          return parseTransactionTimestamp(value);
        }
        return value;
      },
    }
  );
}

export default createBusTransactionListInventorySchema;
